module.exports = __webpack_public_path__ + "img/SZ.54b34b5c.png";